import React from "react";
import { Icon } from "@qgiv/core-react";
import "./SearchResult.scss";

/**
 * @param {object} props
 * @param {object} props.result
 * @param {Function} props.handleFocus
 * @param {Function} props.handleResultClick
 * @param {Function} props.handleResultKeyDown
 * @param {number} props.index
 * @param {boolean} props.isDtD
 * @param {Array} props.searchResults
 * @returns {React.JSX.Element}
 */
const SearchResult = ({
    result,
    handleFocus,
    handleResultClick,
    handleResultKeyDown,
    index,
    isDtD,
    searchResults,
}) => (
    <>
        {index === 0 && (
            <div
                className="-margin-top--10 -margin-bottom--10"
                id="search-results-description"
            >
                Please select your employer:
            </div>
        )}
        <button
            className="gift-matching__result"
            onClick={() => {
                handleResultClick(result);
            }}
            onFocus={() => handleFocus(index)}
            onKeyDown={(e) => handleResultKeyDown(e, index, searchResults)}
            aria-label={
                index === 0
                    ? `Please select your employer. ${result.company_name}`
                    : result.company_name
            }
            id={`gift-matching__result-${index}`}
            type="button"
            role="option"
            aria-selected={false}
        >
            <div className="gift-matching__result--container">
                <Icon
                    ariaHidden
                    className="gift-matching__result-building"
                    glyph="building-regular"
                    type="FontAwesome"
                />
                <div className="gift-matching__result-name">
                    <span className="gift-matching__company-name">
                        {result.company_name}
                    </span>
                    {result.subsidiaryOf && isDtD && (
                        <span className="gift-matching__subsidiary-of">
                            {" "}
                            (<em>{result.subsidiaryOf}</em>)
                        </span>
                    )}
                </div>
            </div>
        </button>
    </>
);

export default SearchResult;
